<div *ngIf="instruction$ | async as instruction">
	<div class="p-6">
		<ui-content-header type="page" title="Mortgage Details">
			<img
				actions
				src="/assets/images/integrations/sync-logo.png"
				alt="Closer SYNC"
				class="w-14"
			/>
		</ui-content-header>
		<div class="grid grid-cols-12 gap-6 min-h-0">
			<ui-section [uiColSpan]="6" title="Lender">
				<ng-container section-content>
					<div class="flex flex-col gap-4">
						<div class="flex flex-col gap-2">
							<ui-info-row
								infoLabel="Lender"
								[infoValue]="instruction?.lender?.name"
							/>
							<ui-info-row
								infoLabel="Mortgagee"
								[infoValue]="instruction?.mortgagee?.name"
							/>
						</div>
						<div>
							<div class="h4 mb-2">Service Address</div>
							<ui-card>
								<div card-content>
									<ui-info-row
										infoLabel="Branch"
										*ngIf="instruction?.mortgagee?.serviceAddress?.name"
										[infoValue]="instruction?.mortgagee?.serviceAddress?.name"
									/>
									<ui-info-row
										*ngIf="
											instruction?.mortgagee?.serviceAddress?.transitNumber
										"
										infoLabel="Transit"
										[infoValue]="
											instruction?.mortgagee?.serviceAddress?.transitNumber
										"
									/>
									<ui-info-row
										*ngIf="
											instruction?.mortgagee?.serviceAddress?.address
												?.streetAddress1
										"
										infoLabel="Address"
									>
										<ui-address
											[address]="
												instruction?.mortgagee?.serviceAddress?.address
													| mortgageAddressConverter
											"
										></ui-address>
									</ui-info-row>
								</div>
							</ui-card>
						</div>
						<div
							*ngIf="
								instruction?.mortgagee?.reportAddress?.address?.streetAddress1
							"
						>
							<div class="h3 mb-2">Report Address</div>
							<ui-card>
								<div card-content>
									<ui-info-row
										*ngIf="instruction?.mortgagee?.reportAddress?.name"
										infoLabel="Branch"
										[infoValue]="instruction.mortgagee.reportAddress.name"
									/>
									<ui-info-row
										*ngIf="instruction?.mortgagee?.reportAddress?.transitNumber"
										infoLabel="Transit"
										[infoValue]="
											instruction?.mortgagee?.reportAddress?.transitNumber
										"
									/>
									<ui-info-row
										*ngIf="
											instruction?.mortgagee?.reportAddress?.address
												?.streetAddress1
										"
										infoLabel="Address"
									>
										<ui-address
											[address]="
												instruction?.mortgagee?.reportAddress?.address
													| mortgageAddressConverter
											"
										></ui-address>
									</ui-info-row>
								</div>
							</ui-card>
						</div>
					</div>
				</ng-container>
			</ui-section>
			<ui-section title="Mortgage Details" [uiColSpan]="6">
				<div section-content class="flex flex-col gap-2">
					<ui-info-row
						infoLabel="Mortgage Priority"
						[infoValue]="instruction?.properties?.[0]?.mortgagePriority"
					/>
					<ui-info-row
						infoLabel="Mortgage Type"
						[infoValue]="instruction?.mortgageType"
					/>
					<ui-info-row
						infoLabel="Charge Type"
						[infoValue]="instruction?.chargeType"
					/>
					<ui-info-row
						infoLabel="Standard Charge Terms"
						[infoValue]="instruction?.mortgageOptions?.standardChargeTerm"
					/>
					<ui-info-row
						*ngIf="isPurchase"
						infoLabel="Purchase Price"
						[infoValue]="instruction?.purchasePrice | centsToDollars"
					/>
					<ui-info-row
						infoLabel="Loan Ref #"
						[infoValue]="instruction?.mortgageLoanNumber"
					/>
					<ui-info-row
						infoLabel="Credit Application #"
						[infoValue]="instruction?.creditApplicationNumber"
						*ngIf="!!instruction?.creditApplicationNumber"
					/>
					<ui-info-row
						infoLabel="Closing Date"
						[infoValue]="instruction?.closingDate | date"
					/>
					<ui-info-row infoLabel="Property Address">
						<ui-address
							[address]="instruction?.properties?.[0]?.address"
							type="regular"
						></ui-address>
					</ui-info-row>
					<ui-info-row
						infoLabel="Legal Description"
						[infoValue]="instruction?.properties[0]?.legalDescription"
					/>
				</div>
			</ui-section>
			<ui-section title="Contacts" [uiColSpan]="6">
				<div section-content uiInfoRowList>
					<div *ngFor="let item of instruction.mortgagors">
						<div
							*ngIf="item.mortgagorType === 'PERSON'"
							class="flex gap-3 items-center"
						>
							<atomic-name-badge
								[firstName]="item.firstName"
								[lastName]="item.lastName"
							></atomic-name-badge>
							<div class="flex flex-col">
								<div class="flex gap-2">
									<span>{{ item.firstName }}</span>
									<span>{{ item.lastName }}</span>
								</div>
								<div class="text-sm text-grey-light">Mortgagor</div>
							</div>
						</div>

						<div
							*ngIf="item.mortgagorType === 'BUSINESS'"
							class="flex gap-3 items-center"
						>
							<atomic-name-badge
								*ngIf="item.mortgagorType === 'BUSINESS'"
								[name]="item.companyName"
							></atomic-name-badge>
							<div class="flex flex-col">
								<div>{{ item.companyName }}</div>
								<div class="flex gap-2">
									<span>Signing Officer:</span>
									<span>{{ item.firstName }}</span>
									<span>{{ item.lastName }}</span>
								</div>
								<div class="text-sm text-grey-light">Mortgagor</div>
							</div>
						</div>
					</div>
					<div *ngFor="let item of instruction.guarantors">
						<div
							*ngIf="item.guarantorType === 'PERSON'"
							class="flex gap-3 items-center"
						>
							<atomic-name-badge
								[firstName]="item.firstName"
								[lastName]="item.lastName"
							></atomic-name-badge>
							<div class="flex flex-col">
								<div class="flex gap-2">
									<span>{{ item.firstName }}</span>
									<span>{{ item.lastName }}</span>
								</div>
								<div class="text-sm text-grey-light">Guarantor</div>
							</div>
						</div>

						<div
							*ngIf="item.guarantorType === 'BUSINESS'"
							class="flex gap-3 items-center"
						>
							<atomic-name-badge [name]="item.companyName"></atomic-name-badge>
							<div class="flex flex-col">
								<div>{{ item.companyName }}</div>
								<div class="flex gap-2">
									<span>Signing Officer:</span>
									<span>{{ item.firstName }}</span>
									<span>{{ item.lastName }}</span>
								</div>
								<div class="text-sm text-grey-light">Guarantor</div>
							</div>
						</div>
					</div>
					<div
						*ngIf="
							instruction?.lender?.branchRepresentativeName &&
							instruction?.lender?.syncFlowType === 'email'
						"
						class="flex gap-3 items-center"
					>
						<atomic-name-badge
							[name]="instruction?.lender?.branchRepresentativeName"
						></atomic-name-badge>
						<div class="flex flex-col">
							<div>{{ instruction?.lender?.branchRepresentativeName }}</div>
							<div class="text-sm text-grey-light">
								<span>Mortgage Funder</span>
								<span
									*ngIf="instruction?.lender?.branchRepresentativePhoneNumber"
									>&nbsp;•&nbsp;{{
										instruction?.lender?.branchRepresentativePhoneNumber
									}}</span
								>
								<span *ngIf="instruction?.lender?.branchRepresentativeEmail"
									>&nbsp;•&nbsp;{{
										instruction?.lender?.branchRepresentativeEmail
									}}</span
								>
							</div>
						</div>
					</div>
				</div>
			</ui-section>

			<ui-section
				title="Notes"
				[isEmpty]="!instruction?.note"
				emptyMessage="No notes on mortgage"
				[uiColSpan]="6"
			>
				<div section-content>
					{{ instruction?.note }}
				</div>
			</ui-section>

			<ui-section title="Loan Amount" [uiColSpan]="6">
				<div section-content uiInfoRowList>
					<ui-info-row
						infoLabel="Principal Amount"
						[infoValue]="
							instruction?.mortgagePayment?.principalAmount | centsToDollars
						"
					></ui-info-row>
					<ui-info-row
						infoLabel="Retained By Lender"
						[infoValue]="
							instruction?.mortgagePayment?.retainedByLenderAmount
								| centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.retainedByLenderAmount > 0"
					></ui-info-row>
					<ui-info-row
						infoLabel="Appraisal Fee"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.appraisalFee | centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.appraisalFee"
					></ui-info-row>
					<ui-info-row
						infoLabel="Broker Fee"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.brokerFee | centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.brokerFee"
					></ui-info-row>
					<ui-info-row
						infoLabel="Default Insurance Amount"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.defaultInsuranceAmount
								| centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.defaultInsuranceAmount"
					></ui-info-row>
					<ui-info-row
						infoLabel="Default Application Fee"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.defaultInsuranceApplicationFee
								| centsToDollars
						"
						*ngIf="
							instruction?.mortgagePayment?.fees?.defaultInsuranceApplicationFee
						"
					></ui-info-row>
					<ui-info-row
						infoLabel="Default Insurance Tax Amount"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.defaultInsuranceTaxAmount
								| centsToDollars
						"
						*ngIf="
							instruction?.mortgagePayment?.fees?.defaultInsuranceTaxAmount
						"
					></ui-info-row>
					<ui-info-row
						infoLabel="EFT Fee"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.eftFee | centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.eftFee"
					></ui-info-row>
					<ui-info-row
						infoLabel="Holdback Fee"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.holdback | centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.holdback"
					></ui-info-row>
					<ui-info-row
						infoLabel="Interest Adjustment"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.interestAdjustment
								| centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.interestAdjustment"
					></ui-info-row>
					<ui-info-row
						infoLabel="Lender Fee"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.lenderFee | centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.lenderFee"
					></ui-info-row>
					<ui-info-row
						infoLabel="Miscellaneous"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.miscellaneousFee
								| centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.miscellaneousFee"
					></ui-info-row>
					<ui-info-row
						infoLabel="Property Tax Holdback"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.propertyTaxHoldback
								| centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.propertyTaxHoldback"
					></ui-info-row>
					<ui-info-row
						infoLabel="Wire Fee"
						[infoValue]="
							instruction?.mortgagePayment?.fees?.wireFee | centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.wireFee"
					></ui-info-row>
					<ui-info-row
						infoLabel="Cashback Credit"
						[infoValue]="
							'+' + instruction?.mortgagePayment?.fees?.credits?.cashBackAmount
								| centsToDollars
						"
						*ngIf="instruction?.mortgagePayment?.fees?.credits?.cashBackAmount"
					></ui-info-row>
					<ui-info-row
						infoLabel="Prepayment Refund"
						[infoValue]="
							'+' +
								instruction?.mortgagePayment?.fees?.credits?.prepaymentRefund
								| centsToDollars
						"
						*ngIf="
							instruction?.mortgagePayment?.fees?.credits?.prepaymentRefund
						"
					></ui-info-row>
					<ui-info-row
						infoLabel="Net Advanced Amount"
						[infoValue]="
							instruction?.mortgagePayment?.netAdvanceAmount | centsToDollars
						"
					></ui-info-row>
				</div>
			</ui-section>
			<ui-section title="Terms" [uiColSpan]="6">
				<div section-content uiInfoRowList>
					<ui-info-row
						infoLabel="Term"
						[infoValue]="instruction?.mortgagePayment?.mortgageTerm"
					></ui-info-row>
					<ui-info-row
						infoLabel="Amortization"
						[infoValue]="instruction?.mortgagePayment?.amortization"
					></ui-info-row>
					<ui-info-row
						infoLabel="Interest Rate Type"
						[infoValue]="instruction?.mortgagePayment?.interestRateType"
					></ui-info-row>
					<ui-info-row
						infoLabel="Interest Rate"
						[infoValue]="instruction?.mortgagePayment?.interestRateAsReg"
					></ui-info-row>
					<ui-info-row
						infoLabel="Calculation Period"
						[infoValue]="instruction?.mortgagePayment?.calculationPeriodAsReg"
					></ui-info-row>
				</div>
			</ui-section>
			<ui-section title="Payments" [uiColSpan]="12">
				<div section-content>
					<div class="grid grid-cols-3 gap-y-2">
						<div></div>
						<div>
							<h4 class="h4">Registered</h4>
						</div>
						<div>
							<h4 class="h4">Actual</h4>
						</div>

						<!-- Row 1 -->
						<div>
							<p class="p text-gray-950">Payment Frequency</p>
						</div>
						<div>
							<p class="p">
								{{ instruction?.mortgagePayment?.paymentFrequencyAsReg || '-' }}
							</p>
						</div>
						<div>
							<p class="p">
								{{ instruction?.mortgagePayment?.paymentFrequency || '-' }}
							</p>
						</div>

						<!-- Row 2 -->
						<div>
							<p class="p text-gray-950">Payment Date and Period</p>
						</div>
						<div>
							<p class="p">
								{{ instruction?.mortgagePayment?.paymentsDueAsReg || '-' }}
							</p>
						</div>
						<div>
							<p class="p">
								{{ instruction?.mortgagePayment?.paymentsDue || '-' }}
							</p>
						</div>

						<!-- Row 3 -->
						<div>
							<p class="p text-gray-950">Amount Per Payment</p>
						</div>
						<div>
							<p class="p">
								{{
									(instruction?.mortgagePayment?.totalRegularPaymentAsReg
										| centsToDollars) || '-'
								}}
							</p>
						</div>
						<div>
							<p class="p">
								{{
									(instruction?.mortgagePayment?.totalRegularPayment
										| centsToDollars) || '-'
								}}
							</p>
						</div>

						<!-- Row 4 -->
						<ng-container
							*ngIf="instruction?.mortgagePayment?.principalAndInterestPayment"
						>
							<div>
								<p class="p text-gray-950">Principal and Interest Payment</p>
							</div>
							<div>
								<p class="p"></p>
							</div>
							<div>
								<p class="p">
									{{
										(instruction?.mortgagePayment?.principalAndInterestPayment
											| centsToDollars) || '-'
									}}
								</p>
							</div>
						</ng-container>

						<!-- Row 5 -->
						<ng-container
							*ngIf="instruction?.mortgagePayment?.propertyTaxPortion"
						>
							<div>
								<p class="p text-gray-950">Property Tax Portion</p>
							</div>
							<div>
								<p class="p"></p>
							</div>
							<div>
								<p class="p">
									{{
										(instruction?.mortgagePayment?.propertyTaxPortion
											| centsToDollars) || '-'
									}}
								</p>
							</div>
						</ng-container>

						<!-- Row 6 -->
						<ng-container
							*ngIf="instruction?.mortgagePayment?.insurancePortion"
						>
							<div>
								<p class="p text-gray-950">Insurance Portion</p>
							</div>
							<div>
								<p class="p"></p>
							</div>
							<div>
								<p class="p">
									{{
										(instruction?.mortgagePayment?.insurancePortion
											| centsToDollars) || '-'
									}}
								</p>
							</div>
						</ng-container>
					</div>
				</div>
			</ui-section>

			<ui-section title="Dates" [uiColSpan]="12">
				<div section-content>
					<div class="grid grid-cols-3 gap-y-2">
						<!-- Headings -->
						<div></div>
						<div>
							<h4 class="h4">Registered</h4>
						</div>
						<div>
							<h4 class="h4">Actual</h4>
						</div>
						<!-- Row 1 -->
						<div>
							<p class="p text-gray-950">Interest Adjustment Date</p>
						</div>
						<div>
							<p class="p">
								{{
									(instruction?.mortgagePayment?.interestAdjustmentDateAsReg
										| dateParser: 'MMM d, y') || '-'
								}}
							</p>
						</div>
						<div>
							<p class="p">
								{{
									(instruction?.mortgagePayment?.interestAdjustmentDate
										| date) || '-'
								}}
							</p>
						</div>

						<!-- Row 2 -->
						<div>
							<p class="p text-gray-950">First Payment Date</p>
						</div>
						<div>
							<p class="p">
								{{
									(instruction?.mortgagePayment?.firstPaymentDateAsReg
										| dateParser: 'MMM d, y') || '-'
								}}
							</p>
						</div>
						<div>
							<p class="p">
								{{
									(instruction?.mortgagePayment?.firstPaymentDate | date) || '-'
								}}
							</p>
						</div>

						<!-- Row 3 -->
						<div>
							<p class="p text-gray-950">Last Payment Date</p>
						</div>
						<div>
							<p class="p">
								{{
									(instruction?.mortgagePayment?.lastPaymentDateAsReg
										| dateParser: 'MMM d, y') || '-'
								}}
							</p>
						</div>
						<div>
							<p class="p">
								{{
									(instruction?.mortgagePayment?.lastPaymentDate | date) || '-'
								}}
							</p>
						</div>

						<!-- Row 4 -->
						<div>
							<p class="p text-gray-950">Maturity Date</p>
						</div>
						<div>
							<p class="p">
								{{
									(instruction?.mortgagePayment?.maturityDateAsReg
										| dateParser: 'MMM d, y') || '-'
								}}
							</p>
						</div>
						<div>
							<p class="p">
								{{ (instruction?.mortgagePayment?.maturityDate | date) || '-' }}
							</p>
						</div>
					</div>
				</div>
			</ui-section>
		</div>
	</div>
</div>
